"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.booleanProp = void 0;

var util_1 = require("../util");
/**
 * Allows any boolean (validated at runtime and compile time).
 *
 * @param validator - Optional function for further runtime validation; should return `undefined` if valid, or an error string if invalid.
 */


var booleanProp = function booleanProp(validator) {
  return (0, util_1.propOptionsGenerator)(Boolean, validator);
};

exports.booleanProp = booleanProp;